import { TableCell, TableRow, Typography, TableBody } from "@mui/material";
import React, { useRef, useState } from "react";
import FormRow from "./FormRow";
import { getUserData } from "services/utils";
import { isISODateString } from "../services";
import StructureForm from "../Structure/StructureForm";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

const FormRows = (props) => {
  const { columns, rows, config, errorRef, helperFunction, onReorder } = props;
  const { checkValidation } = helperFunction;

  const [_, forceUpdate] = useState({});
  const render = () => forceUpdate({});

  const esignData = () => ({
    time: new Date().toISOString(),
    userData: getUserData(config?.userData),
  });

  const helperUtils = (event) => {
    if (event === "checkValidation") return checkValidation();
    else if ("esignData") return esignData();
  };

  const stateRef = useRef({ trackColumnChanges: [] });

  const handleVisibility = (obj) => {
    config.hanlderRef.current.visibility = obj;
    config.renderForm();
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination } = result;
    const sourceIndex = source.index;
    const destinationIndex = destination.index;
    const updatedColumns = Array.from(columns);
    const [movedItem] = updatedColumns.splice(sourceIndex, 1);
    updatedColumns.splice(destinationIndex, 0, movedItem);
    columns.length = 0;
    updatedColumns.forEach((col) => columns.push(col));
    render();
  };


  return (
    <DragDropContext onDragEnd={handleDragEnd} >
      <Droppable droppableId="droppable-formrows">
        {(provided) => (
          <TableBody
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {columns?.map((column, columnIndex) => {
              if (
                typeof config?.hanlderRef?.current?.visibility?.[
                column?.uniqueName
                ] === "boolean"
              ) {
                if (
                  config?.hanlderRef.current.visibility?.[
                  column?.uniqueName
                  ] === true
                ) {
                  return null;
                }
              }

              return (
                <Draggable
                  key={column?.uniqueName}
                  draggableId={String(column?.uniqueName)}
                  index={columnIndex}
                  isDragDisabled={!config?.isStructure}
                >
                  {(provided, snapshot) => (
                    <TableRow
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      sx={{
                        width: "100%",
                        backgroundColor: snapshot.isDragging
                          ? "#f9f9f9"
                          : "inherit",
                      }}
                    >
                      {!!config?.isStructure && !config?.isViewMode && (<TableCell
                        {...provided.dragHandleProps}
                        sx={{ width: "40px", cursor: "grab" }}
                      >
                        <DragIndicatorIcon fontSize="small" />
                      </TableCell>)}

                      {Object.hasOwn(column, "isHeading") &&
                        column?.isHeading ? (
                        <TableCell
                          align="center"
                          colSpan={2}
                          sx={{ fontWeight: "bold", padding: "16px" }}
                        >
                          <Typography variant="h5">{column?.name}</Typography>
                        </TableCell>
                      ) : (
                        <>
                          {!!config?.isStructure && !config?.isViewMode ? (
                            <StructureForm
                              column={column}
                              columns={columns}
                              render={render}
                              index={columnIndex}
                              rows={rows}
                              config={config}
                              stateRef={config?.hanlderRef}
                            />
                          ) : (
                            <TableCell>{column?.name ?? "N/A"}</TableCell>
                          )}
                          <FormRow
                            rows={rows}
                            column={column}
                            columnIndex={columnIndex}
                            config={{ ...config }}
                            errorRef={errorRef}
                            helperFunction={{
                              ...helperFunction,
                              helperUtils,
                              handleVisibility,
                              isISODateString,
                            }}
                          />
                        </>
                      )}
                    </TableRow>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </TableBody>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default FormRows;
